export default __webpack_public_path__ + "static/media/smiley-04.19641c0e.png";